module.exports = "https://sf6-scmcdn2-tos.pstatp.com/motor/pc/_next/static/images/empty-envelope-e4cce1b51cf6b41f3b8841970dc0d6de.png";